import _ from 'lodash';
import {useContext, useEffect, useRef, useState} from 'react';
import {faSync} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ApplicableTableSettings, codesEdi315List} from '../../../tableSettings';

import useFastStorage from '../../../hooks/useFastStorage';
import useFunction from '../../../hooks/useFunction';
import ApplicationContext from '../../../ApplicationContext';
import useSystemSettings from '../../../hooks/useSystemSettings';
import { Search } from '../../../filtering';
import { JobNames } from '../../../framework.core/JobNames';
import { CodeEDI315ListItem } from '../../../fms.data/models/CodeEDI315ListItem';
import { SQLType } from '../../../framework.core/data/SQLInfo';
import { Portal } from 'react-portal';
import EditableTable, { CellData, EditableTableHandle, TableCellAligns, TableCellTypes } from '../../../ui/tables/editing/EditableTable';
import { FmsSecTask } from '../../../fms.core/constants';
import GreenButton from '../../../ui/GreenButton';
import ClearableSearch from '../../../uiControls/ClearableSearch';
import TextBox from '../../../ui/TextBox';
import { checkTabIsDirty } from '../ReferenceFiles';
import { findSecurityTask } from '../../../util';
import Float from '../../../ui/Float';
 
import BlackInverseButton from '../../../ui/BlackInverseButton';
import constants from '../../../constants';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import IFmsReferenceFilesContext from '../IfmsReferenceFilesContext';
import CloseButton from '../../../ui/CloseButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';

interface IEdi315 {
  description?: string,
  status?: string,
  equipment?: string,
  ediOrder?:number,
  isNew?: boolean,
}

function EventDescriptionRenderer({data, row, cell}:any) {
  // useEffect(() => {
  //   const focusElement = document.getElementById('ifms-eventdescription') as HTMLInputElement;
  //   if (focusElement) {
  //     focusElement.focus();
  //     focusElement.select();
  //   }
  // },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId="ifms-eventdescription" maxLength={50} value={l.description} onChange={(e) => {
          changeLineItem(row.index,{description: e.target.value, isUpdate:true})
          }} />
      </div>
    );
}


function StatusRenderer({data, row, cell}:any) {

  const l = data[row.index];
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId="ifms-status" maxLength={2} value={l.status} onChange={(e) => {
          changeLineItem(row.index,{status: e.target.value, isUpdate:true})
          }} />
      </div>
    );
}

function EquipRenderer({data, row, cell}:any) {
  const l = data[row.index];
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId="ifms-equip" maxLength={1} value={l.equipment} onChange={(e) => {
          changeLineItem(row.index,{equipment: e.target.value, isUpdate:true})
          }} />
      </div>
    );
}

function OrderRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <Float decimals={0} max={99999999} value={data[row.index].ediOrder} onChange={ediOrder => {
          changeLineItem(row.index, {ediOrder: ediOrder, isUpdate: true});
        }}
      />
        {/* <input
            type="number"
            min={0}
            step={1}
            className="e-ifms-input e-outline ifms-tabable"
            defaultValue={data[row.index].ediOrder}
            onChange={(e) => {
              const i = parseInt(e.target.value);
              changeLineItem(row.index, {ediOrder : (isNaN(i) ? undefined : i), isUpdate:true })
            }}
            autoComplete="off"
            list="autocompleteOff"
            data-tooltip="-from-value"
            
            data-tooltip-onlywhencutoff
          /> */}
      </div>
    );
}


function formatElement(data:any) {
  return data;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function Edi315Component() {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({ onSave: handleSaveAndClose });
  
  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const systemSettings = useSystemSettings();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  
  const tableRef = useRef(null);
  const masterTableRef = useRef<EditableTableHandle>(null);
  const savedDataRef = useRef<Array<CodeEDI315ListItem>>([]);
  const oriData = useRef<CodeEDI315ListItem[]>([]);
  //const addingToTheFirstLine = useRef(false);

  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, ] = useFastStorage(`ifms-referenceFiles-edi315-list`, []);
  //const [ei, setEi, , ] = useFastStorage(`ifms-referenceFiles-edi315-editindex`, -1);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-edi315-orderby`, {
    orderBy: 'description',
    orderByAscending: true,
    general1: 'Description',
    //generalText1: '',   //<pt220819>
    pageSize: systemSettings.defaultPageSize,
  });

  const tableHeight = 520;
  const listItemType = 'CodeEDI315ListItem';

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeEDI315Code);
  const [focusFirstCell, setFocusFirstCell] = useState(true);

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function setData(d:Array<IEdi315>, callByFetchData: boolean = false) {
    setFocusFirstCell(callByFetchData);
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeEDI315ListItem, oriData.current, d));
  }

  async function fetchData(api:any, search: Search) {
    setLoading(true);

    const apiResult = await api.getListItems(JobNames.EDI310Code,
      listItemType,
      CodeEDI315ListItem.calculateSearchParameters(search,CodeEDI315ListItem.MapSearchFields),
      1, search.pageSize);
    oriData.current = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    setData(formatData(apiResult && apiResult.entities ? apiResult.entities : []), true);
    savedDataRef.current = apiResult && apiResult.entities ? apiResult.entities : [];

    setFocusFirstCell(false);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (data.length === 0)
      reload();
    else {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // useEffect(() => {
  //    inlineElement = {};
  //    setEi(-1);
  //   reload();
  //   return () => {
  //     tableNavigationCleanup();
  //   };
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );


  async function reload(generalText:string = '') {
    setOrderBy({
      orderBy: 'description',
      orderByAscending: true,
      pageSize: systemSettings.defaultPageSize,
      generalText1: generalText,
    })

    await fetchData(appContext.api, orderBy);
  }
  
  function applyToLineItem(rowIndex:number, change:any) {
    if (!change) {
      return;
    }
    const newData = [...data]; 
    const checkData = data[rowIndex];
    if (!change.isNew && (change.description !== checkData.description || change.status !== checkData.status ||
      change.equipment !== checkData.equipment || change.ediOrder !== checkData.ediOrder)) {
    _.merge(newData[rowIndex], {...change, hasBeenChanged: true});
    //setHasChanges(true);
    setData(newData);
    }
  }
  // function addingLineToFirstLine(){
  //   addingToTheFirstLine.current = true;
  //   masterTableRef.current?.add();
  // }

  function addLineItem() {
    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: { id: 0, description: '', status: '', equipment: '', ediOrder: null, isNew: true }
    };
  }
  
  function cancelOperation() {
    setHasChanges(false);
    removeData();
    return true;
  }

  function deleteEntity(index: number): boolean {
    if(!data){
      return false;
    }

    const element = data[index];
    if(element.id > 0 ){
       let deleteRow = savedDataRef.current.find(x=>x.id === element.id)
       if(deleteRow){
         deleteRow.isDelete = true;
         //setHasChanges(true);
       }
    }
    data.splice(index, 1);
    setData(data);
    return true;
  }

  async function save() {
    // if (!inlineElement.isNew && !hasChanges) {
    //   cancelOperation();
    //   return false;
    // }

    //<pt220819: portal
    // const apiResult = inlineElement.isNew
    //   ? await appContext.api.createCodesEdi315(_.omit(inlineElement, ['isNew']))
    //   : await appContext.api.editCodesEdi315(_.omit(inlineElement, ['isNew']));
    
    // if (!apiResult || !apiResult.success) {
    //   return;
    // }

    // data[ei] = formatElement(apiResult.data);
    if (!data) {
      return;
    }

    let validData = data.filter((x: any) => x.description);
    validData.forEach((x: any) => {
      if (x.ediOrder === null)
        x.ediOrder = undefined;
    })

    let errMsg = '';
    const newData = validData.filter((x:any) => x.id <= 0 || x.hasBeenChanged === true);
    const deleteData = savedDataRef.current.filter((x)=>x.isDelete);
    if(newData.length === 0 && deleteData.length === 0) {
      if (hasChanges) reload(orderBy?.generalText1 || '');
      return;
    }
    setLoading(true);
    
    for(let i = 0; i < deleteData.length; ++i){
      const s = deleteData[i];
      const apiResult = await appContext.api.saveListItem(listItemType,SQLType.Delete, _.omit(s,['isDelete']));
      if(!apiResult || !apiResult.success){
        errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
      }
    }
    if(newData.length > 0){
      const apiResult = await appContext.api.saveList(listItemType, newData);

      if(!apiResult || !apiResult.success){
        errMsg += (errMsg ? '\n' : '' ) + apiResult?.message;
      }

      if(apiResult?.result) {
        apiResult?.result.forEach((item: any) => {
          const index = data.findIndex((d: any) => d.id === item.oldId);
          if(index >= 0){
            data[index].id = item.newId;
            data[index].hasBeenChanged = false;
          }
        });
      }
    }

    //pt220819>
    //cancelOperation(true);
    if(errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }
    // setData(data);
    // savedDataRef.current = _.cloneDeep(data);
    // oriData.current = _.cloneDeep(data);
    
    // setLoading(false);
    // setHasChanges(false);
    //cancelOperation();
    reload(orderBy?.generalText1 || '');
    
    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-edi315-list',
    ref: tableRef,
    selectable: true,
    tableName: 'edi315TypeList',
    ...codesEdi315List,
    height: `${tableHeight}px`,
    //data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, requestOperationCancel})),
    data: data.map((x:any, i: number) => ({...x, indicator:(i+1).toString(), changeLineItem : applyToLineItem})),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'description', EditCell: EventDescriptionRenderer },
      { accessor: 'status',  EditCell: StatusRenderer },
      { accessor: 'equipment', EditCell: EquipRenderer },
      { accessor: 'ediOrder',  EditCell: OrderRenderer },
      //{ accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'description')
        return { type: TableCellTypes.Text, value: data[rowIndex].description };
      else if (accessor === 'status')
       return { type: TableCellTypes.Text, value: data[rowIndex].status, align: TableCellAligns.Center };
      else if (accessor === 'equipment')
        return { type: TableCellTypes.Text, value: data[rowIndex].equipment, align: TableCellAligns.Center};
      else if (accessor === 'ediOrder')
        return { type: TableCellTypes.Number, decimal:0, value: data[rowIndex].ediOrder, align: TableCellAligns.Center};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const canSelectForNew = ei === -1;

  return (
    <div style={{marginTop: '40px'}}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>EDI315</h1>
      </Portal> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element">
            <GreenButton size="regular" disabled={loading} onClick={save}>Save</GreenButton>
          </div>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='codes-currency-refresh-button' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={() => { reload(orderBy?.generalText1 || '') }} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>



      <div style={{ display: 'flex', width: '680px' }}>
        <div style={{width: '320px', fontWeight: 'bold'}}>
          {/* <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})} /> */}
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={async generalText1 => {await reload(generalText1 === null ? '' : generalText1); }} />
        </div>

        <div style={{ marginLeft: 'auto' }}></div>
        
        <div style={{ position: 'relative', top: '-4px' }}>
          {//<SecondaryButton name='codes-edi315-add-button' size="regular" disabled={!listSec?.grantAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} />&nbsp; Add Line</SecondaryButton> &nbsp; 
          }
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(orderBy?.generalText1 || '') }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      <div style={{ width: '680px' }}>
      {/* <SmartTable {...tableOptions} /> */}
      <EditableTable
        initializeFocusedCell={focusFirstCell}
        ref={masterTableRef}
        tableOptions={tableOptions}
        deleteLine={deleteEntity}
        addLine={addLineItem}
        getIndexOfFirstInvalidCell={() => {return undefined}}
        canDeleteRow={rowNumber => listSec?.grantDel??false}
      />
</div>
    </div>
  );
}

export default Edi315Component;